import { render, staticRenderFns } from "./InfoWindowOptimisedStopContent.vue?vue&type=template&id=40b35b72&scoped=true&"
import script from "./InfoWindowOptimisedStopContent.vue?vue&type=script&lang=js&"
export * from "./InfoWindowOptimisedStopContent.vue?vue&type=script&lang=js&"
import style0 from "./InfoWindowOptimisedStopContent.vue?vue&type=style&index=0&id=40b35b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b35b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b35b72')) {
      api.createRecord('40b35b72', component.options)
    } else {
      api.reload('40b35b72', component.options)
    }
    module.hot.accept("./InfoWindowOptimisedStopContent.vue?vue&type=template&id=40b35b72&scoped=true&", function () {
      api.rerender('40b35b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Map/components/InfoWindowOptimisedStopContent.vue"
export default component.exports